import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { ciHttpRequest } from '../../../utils/CiHttpRequest';
import {
	IPurchaseRoSearch,
	IPurchaseRoDetail,
	IPurchaseRoStatistics,
} from './vrmBillPurchaseRoType';
class PurchaseRoService {
	async total(searchVo: IPurchaseRoSearch) {
		const apiUrl = '/vrm2/preturn/total';
		return await appHttpRequest.post<IPurchaseRoStatistics>(apiUrl, searchVo);
	}
	async one(id: string,userBranch:string) {
		const apiUrl =userBranch=='vrm'? `/vrm2/preturn/findById/${id}`:`/ci-storage/preturn/findById/${id}`;
		return await userBranch=='vrm'?appHttpRequest.get<IPurchaseRoDetail>(apiUrl):ciHttpRequest.get<IPurchaseRoDetail>(apiUrl);
	}
}

export const purchaseRoService = new PurchaseRoService();
